import { render, staticRenderFns } from "./EmployeeStandByEdit.vue?vue&type=template&id=48a28c81&"
import script from "./EmployeeStandByEdit.vue?vue&type=script&lang=ts&"
export * from "./EmployeeStandByEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports